import { OverlayTrigger, Popover } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

const MyOverlayTrigger = ({
  id,
  children,
  title,
  width,
  trigger,
  close,
  placement
}: {
  id?: string;
  children: any;
  title: any;
  width?: string | number;
  trigger?: "hover" | "click" | "focus";
  close?: boolean;
  placement?: Placement;
}) => {
  const renderPopover = (props: any) => (
    <Popover
      id={id}
      className="tw-p-[7px] tw-bg-gray-900 tw-rounded-lg tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-text-center tw-text-gray-50 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal"
      {...props}
    >
      <div>{title}</div>
    </Popover>
  );

  return (
    <OverlayTrigger
      show={close ? false : undefined}
      trigger={trigger ? [trigger] : ["hover", "focus"]}
      delay={{ show: 250, hide: 400 }}
      placement={placement ? placement : undefined}
      overlay={renderPopover}
    >
      {children}
    </OverlayTrigger>
  );
};

export default MyOverlayTrigger;
